import { render, staticRenderFns } from "./vu-meter.vue?vue&type=template&id=d38b4f28&scoped=true&"
import script from "./vu-meter.vue?vue&type=script&lang=js&"
export * from "./vu-meter.vue?vue&type=script&lang=js&"
import style0 from "./vu-meter.vue?vue&type=style&index=0&id=d38b4f28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38b4f28",
  null
  
)

export default component.exports